import { Controller } from "stimulus";

// Counting down never flips to counting up by itself: the sibling show_controller.js either reloads
// the page at zero (re-rendering this fresh from the server) or, for a premiere whose player was
// mounted early, starts it in place and signals premiere-start, which flips this in place (start).
export default class EditorialInfoPanelComponent extends Controller {
  static targets = ["timer", "viewersBadge", "viewersLabel", "liveBadge", "ticketChip"];
  static values = {
    timerMs: Number,
    waiting: Boolean,
    playbackEndsAtMs: Number,
    // Seeded only on a premiere that starts in place: what the viewer count reads once it plays.
    watchingLabel: String,
  };

  connect() {
    if (!this.timerMsValue) return;

    this.tick();
    this.timerInterval = window.setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    if (this.timerInterval) window.clearInterval(this.timerInterval);
  }

  // The premiere began without a reload: count up from its start and show it as live.
  start() {
    this.waitingValue = false;
    this.viewersLabelTargets.forEach((label) => { label.textContent = this.watchingLabelValue; });
    this.viewersBadgeTargets.forEach((badge) => { badge.title = `Viewers ${this.watchingLabelValue}`; });
    if (this.hasLiveBadgeTarget) this.liveBadgeTarget.classList.remove("hidden");
    this.ticketChipTargets.forEach((chip) => chip.classList.add("hidden"));
    this.tick();
  }

  tick() {
    const now = Date.now();

    if (this.hasTimerTarget) {
      const clampedNow = !this.waitingValue && this.playbackEndsAtMsValue ? Math.min(now, this.playbackEndsAtMsValue) : now;
      const diff = Math.abs(clampedNow - this.timerMsValue);
      this.timerTarget.textContent = this.waitingValue ? `Starts in ${this.format(diff)}` : `Started ${this.format(diff)} ago`;
    }

    if (!this.waitingValue && this.playbackEndsAtMsValue && now >= this.playbackEndsAtMsValue && this.timerInterval) {
      window.clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  format(ms) {
    const minutes = Math.floor(ms / 60000);
    if (minutes < 1) return "less than a minute";
    if (minutes === 1) return "1 minute";
    return `${minutes} minutes`;
  }
}
